import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '../views/Home.vue'
import Signin from '../views/Signin.vue'
import Signup from '../views/Signup.vue'
import Mypage from '../views/Mypage.vue'
import { Page } from '../type'
import store from '../store'
import {
  isAdminRoute,
  needAutoSigninRoute,
  isUserAdmin,
  isUserSignedIn
} from '../lib/appHelper'
import AdminUsers from '../views/AdminUsers.vue'
import Users from '../views/Users.vue'
import Terms from '../views/Terms.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: Page.Home,
    component: Home
  },
  {
    path: '/terms',
    name: Page.Terms,
    component: Terms
  },
  {
    path: '/signup',
    name: Page.Signup,
    component: Signup
  },
  {
    path: '/signin',
    name: Page.Signin,
    component: Signin
  },
  {
    path: '/list',
    name: Page.Users,
    component: Users
  },
  {
    path: '/user/management',
    name: Page.Mypage,
    component: Mypage
  },
  {
    path: '/admin/users',
    name: Page.AdminUsers,
    component: AdminUsers
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, _from, next) => {
  if (needAutoSigninRoute(to) && !isUserSignedIn())
    await store.dispatch('user/autoSignin')
  if (isAdminRoute(to) && !isUserAdmin())
    return next({ name: Page.Signin, query: { redirect: Page.AdminUsers } })
  next()
})

export default router
